const allItems = {
  // 代理管理-代理列表
  '/admin/agent/users/queryUsersInFo': [
    { "name": "代理ID", "prop": "id" },
    { "name": "创建日期", "prop": "createDate" },
    { "name": "代理名称", "prop": "nickName" },
    { "name": "邮箱", "prop": "email" },
    { "name": "手机号", "prop": "phone" },
    { "name": "支付宝wap支付费率", "prop": "alipayWapRatio" },
    { "name": "支付宝二维码支付费率", "prop": "alipayQRRatio" },
    { "name": "微信二维码支付费率", "prop": "wechatQRRatio" },
    { "name": "微信wap支付费率", "prop": "wechatWapRatio" },
    { "name": "银联在线支付费率", "prop": "upopRatio" },
    { "name": "状态", "prop": "state" }
  ],
}

export default allItems


// WEBPACK FOOTER //
// ./src/components/TableHide/items.js